import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { ref, computed, watch } from 'vue'
import dayjs from 'dayjs'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { Form } from 'ant-design-vue'

const __default__ = { name: 'CosDateTimeRagePicker' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  startTime: String,
  endTime: String,
  dataFormat: {
    type: String,
    default: 'YYYY/MM/DD'
  },
  dataRequired: {
    type: Boolean,
    default: true
  },
  view: {
    type: Boolean
  },
  placeholder: {
    type: String,
    default: '请选择日期'
  },
  timeRequired: {
    type: Boolean,
    default: true
  },
  timeFormat: {
    type: String,
    default: 'HH:mm'
  }
},
  emits: ['update:startTime', 'update:endTime', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props
const formItemContext = Form.useInjectFormItemContext()
const dateValue = ref<string>()
const timeValue = ref<[string, string] | null>()
let startTimePage = ''
let endTimePage = ''
watch(
  () => [props.startTime, props.endTime],
  (v, prev) => {
    setTimeout(() => {
      const [startTime, endTime] = v
      if (startTime === startTimePage && endTime === endTimePage) {
        return
      }
      if (startTime || endTime) {
        dateValue.value = dayjs(startTime || endTime).format(props.dataFormat)
      } else {
        dateValue.value = ''
        timeValue.value = null
      }
      if (startTime && endTime) {
        const time: [string, string] = [
          dayjs(startTime).format(props.timeFormat),
          dayjs(endTime).format(props.timeFormat)
        ]
        timeValue.value = time
      }
    })
  }
)
const emit = __emit
const ok = () => {
  let time1 = '00:00:00'
  let time2 = '00:00:00'
  let allTime
  const date = dayjs(dateValue.value).format(props.dataFormat)
  if (timeValue.value && timeValue.value.length) {
    time1 = timeValue.value[0] + ':00'
    time2 = timeValue.value[1] + ':00'
  }
  if (props.timeRequired && props.dataRequired) {
    if (!dateValue.value || !timeValue.value || !timeValue.value.length) {
      startTimePage = ''
      endTimePage = ''
      emit('update:startTime', '')
      emit('update:endTime', '')
      return
    }
  }
  startTimePage = date + ' ' + time1
  endTimePage = date + ' ' + time2
  emit('update:startTime', startTimePage)
  emit('update:endTime', endTimePage)
  emit('change')
  formItemContext.onFieldChange()
}

const inputValue = computed(() => {
  if (!props.view) return undefined
  try {
    if (props.startTime && props.endTime) {
      const date = props.startTime.split(' ')[0]
      const start = props.startTime.split(' ')[1]
      const end = props.endTime.split(' ')[1]
      return `${date} ${start}-${end}`
    } else {
      return undefined
    }
  } catch (error) {
    console.error(error)
    return undefined
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_time_range_picker = _resolveComponent("a-time-range-picker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CosInputView, _mergeProps({ key: 0 }, _ctx.$attrs, { value: inputValue.value }), null, 16, ["value"]))
    : (_openBlock(), _createBlock(_component_a_input_group, {
        key: 1,
        compact: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_date_picker, _mergeProps({
            value: dateValue.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event))
          }, _ctx.$attrs, {
            valueFormat: "YYYY/MM/DD",
            style: {"width":"43%"},
            onChange: ok,
            placeholder: props.placeholder
          }), null, 16, ["value", "placeholder"]),
          _createVNode(_component_a_time_range_picker, _mergeProps({
            value: timeValue.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((timeValue).value = $event))
          }, _ctx.$attrs, {
            format: __props.timeFormat,
            valueFormat: __props.timeFormat,
            style: {"width":"57%"},
            onOk: ok
          }), null, 16, ["value", "format", "valueFormat"])
        ]),
        _: 1
      }))
}
}

})